/**
 * @returns {ThunkAction}
 */
export function initialize(selectedDocuments, settings = {}) {
  return (dispatch) => {
    let workstreams = {};

    for (const document of selectedDocuments) {
      if (document.tagWorkstream) {
        for (const workstream of document.tagWorkstream) {
          workstreams = {
            ...workstreams,
            [workstream.value]: workstream,
          };
        }
      }
    }
    dispatch({
      type: 'TAG_FILE_WORKSTRTEAM_INITIALIZE',
      selectedDocuments,
      selectedWorkstreams: Object.values(workstreams),
      tagWorkstreamApi: settings.tagWorkstreamApi,
      onSearchWorkstream: settings.onSearchWorkstream,
    });
  };
}

/**
 * @returns {ThunkAction}
 */
export function reset() {
  return (dispatch) => {
    dispatch({
      type: 'TAG_FILE_WORKSTRTEAM_RESET',
    });
  };
}

/**
 * @returns {ThunkAction}
 */
export function toggleModal(display = true) {
  return (dispatch) => {
    dispatch({
      type: 'TAG_FILE_WORKSTRTEAM_TOGGLE_MODAL_DISPLAY',
      showModal: display,
    });
  };
}

/**
 * @returns {ThunkAction}
 */
export function toggleNoticeModal(display = true) {
  return (dispatch) => {
    dispatch({
      type: 'TAG_FILE_WORKSTRTEAM_TOGGLE_NOTICE_MODAL_DISPLAY',
      showNoticeModal: display,
    });
  };
}

/**
 * @returns {ThunkAction}
 */
export function setSelectedDocuments(selectedDocuments) {
  return (dispatch) => {
    dispatch({
      type: 'TAG_FILE_WORKSTRTEAM_SET_SELECTED_DOCUMENTS',
      selectedDocuments: selectedDocuments,
    });
  };
}

/**
 * @returns {ThunkAction}
 */
export function setSelectedWorkstreams(selectedWorkstreams) {
  return (dispatch) => {
    dispatch({
      type: 'TAG_FILE_WORKSTRTEAM_SET_SELECTED_WORKSTREAMS',
      selectedWorkstreams: selectedWorkstreams,
    });
  };
}

/**
 * @returns {ThunkAction}
 */
export function addWorkstream(workstream) {
  return (dispatch, getState) => {
    const state = getState();
    const { selectedWorkstreams } = state.tagFileWorkstream;
    const workstreams = [...selectedWorkstreams, workstream];

    dispatch(setSelectedWorkstreams(workstreams));
  };
}

/**
 * @returns {ThunkAction}
 */
export function removeWorkstream(workstream) {
  return (dispatch, getState) => {
    const state = getState();
    const { selectedWorkstreams } = state.tagFileWorkstream;
    const workstreams = selectedWorkstreams.map((w) => {
      if (w.value === workstream.value) {
        return {
          ...w,
          isRemoved: true,
        };
      }

      return w;
    });

    dispatch(setSelectedWorkstreams(workstreams));
  };
}

/**
 * @returns {ThunkAction}
 */
export function saveTaggedWorkstreams() {
  return (dispatch, getState) => {
    const state = getState();
    const projectId = state.project.Selected.id;
    const { selectedWorkstreams, selectedDocuments, tagWorkstreamApi } = state.tagFileWorkstream;
    const tagParams = {
      projectId,
      data: selectedDocuments.map((f) => ({
        id: f.linkId,
        type: f.type,
        origin: f.origin,
        oldWorkstreams: selectedWorkstreams
          .filter((w) => w.isRemoved)
          .map((w) => ({ value: w.value, label: w.label, color: w.color })),
        newWorkstreams: selectedWorkstreams
          .filter(
            (w) => !w.isRemoved && f.tagWorkstream.findIndex((ws) => ws.value === w.value) < 0
          )
          .map((w) => ({ value: w.value, label: w.label, color: w.color })),
      })),
    };

    if (
      !tagParams.data.filter(
        (tag) => tag.newWorkstreams.length > 0 || tag.oldWorkstreams.length > 0
      ).length
    ) {
      return Promise.resolve([]);
    }

    dispatch({ type: 'SET_SCREEN_LOADER', Loading: true });

    return tagWorkstreamApi(tagParams).then((response) => {
      let newDocuments = [];

      if (response) {
        const workstreams = selectedWorkstreams.filter((w) => !w.isRemoved);

        newDocuments = selectedDocuments.map((f) => ({
          id: f.id,
          tagWorkstream: workstreams.map((w) => ({
            value: w.value,
            label: w.label,
            color: w.color,
          })),
          workstreams: workstreams.map((w) => w.label),
          activityLogs: response.activities ? response.activities[0] : response.data.activities[0],
        }));
      }

      dispatch({ type: 'SET_SCREEN_LOADER', Loading: false });

      return newDocuments;
    });
  };
}
